/* global requestAnimationFrame */
jQuery( () => {
	const elasticSearchElement = document.querySelector( '.js-elastic-search' );
	const hideClass = 'is-hidden';

	if ( ! elasticSearchElement ) {
		return;
	}

	const elasticSearchLoader = elasticSearchElement.querySelector( '.js-elastic-search-loader' );
	const containerElement = elasticSearchElement.querySelector( '.js-qesf-search-page-header-has-results-container' );
	const paginationElement = elasticSearchElement.querySelector( '#qesf-pagination' );
	const resultsElement = elasticSearchElement.querySelector( '[data-name="qec-results"]' );
	const element404 = elasticSearchElement.querySelector( '.js-qesf-search-page-404' );
	let timeout = null;

	wp.hooks.addAction( 'qalaElasticCore.action.beforeQuery', 'QalaTheme', () => {
		if ( timeout ) {
			clearTimeout( timeout );
		}

		if ( ! elasticSearchLoader.classList.contains( hideClass ) ) {
			return;
		}

		elasticSearchLoader.classList.remove( hideClass );
	} );

	wp.hooks.addAction( 'qalaElasticCore.action.onResult.meta', 'QalaTheme', meta => {
		if ( timeout ) {
			clearTimeout( timeout );
		}

		if ( ! meta || ! meta.page ) {
			return;
		}

		timeout = setTimeout( () => {
			// Try to do everything in one go to minimize any jumping / popup.
			requestAnimationFrame( () => {
				if ( meta?.page?.total_pages === 0 ) {
					show404();
				} else {
					hide404();
				}

				if ( ! elasticSearchLoader.classList.contains( hideClass ) ) {
					elasticSearchLoader.classList.add( hideClass );
				}
			} );
		}, wp.hooks.applyFilters( 'qalaTheme.filter.elastic_search_loader_timeout', 50 ) );
	} );

	const show404 = () => {
		containerElement.classList.add( 'is-hidden' );
		element404.classList.remove( 'is-hidden' );

		paginationElement.style.display = 'none';
		resultsElement.style.display = 'none';
	};

	const hide404 = () => {
		containerElement.classList.remove( 'is-hidden' );
		element404.classList.add( 'is-hidden' );

		paginationElement.style.display = 'initial';
		resultsElement.style.display = 'initial';
	};
} );
